import React, {useState} from 'react';
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {FileUpload} from "primereact/fileupload";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {catchError, getDivisionWiseUrl} from "../../utils/helper";
import {webInfo} from "../../utils/webInfo";
import usePost from "../../hooks/usePost";

const NewCategoryModal = ({visible, setVisible, category,update,setUpdate}: any) => {
    const [selectedCategory, setSelectedCategory] = useState({name: "Select Category", code: null});
    const {post,loading:ploading} = usePost()

    const [item, setItem] = useState<any>({
        name: "",
        image: "",
    });

    const onUploadImage = (event: any) => {
        setItem({
            ...item,
            image: event.files[0],
        })
    };
    const onRemoveImage = () => {
        setItem({
            ...item,
            image: "",
        });
    };
    const handleChange = (e: any) => {
        setItem({
            ...item,
            [e.target.name]: e.target.value,
        })
    }

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">New Category</span>
        </div>
    );



    const footerContent = ()=>{
        const addCategory = async () => {
            const endpoint = getDivisionWiseUrl(selectedCategory.code)?.url;
            const url = `${webInfo.baseUrl}/api/admin/products-${endpoint}-category`;
            const formData = new FormData();
            for (const key in item) {
                formData.append(key, item[key]);
            }
            try {
                // @ts-ignore
                const res:any = await post(url,false,formData);
                if (res.success){
                    setVisible(false);
                    setUpdate(!update)
                }
            }catch (e) {
                catchError(e)
            }
        }
        return <div>
            <Button disabled={ploading} label="Create" icon="pi pi-check" onClick={addCategory} autoFocus/>
        </div>
    };



    return (
        <div>
            <Dialog visible={visible} modal header={headerElement} footer={footerContent} style={{width: '35rem'}}
                    onHide={() => {
                        if (!visible) return;
                        setVisible(false);
                    }}>
                <div>
                    <label htmlFor="">Category Image (62 x 62) *</label>
                    <FileUpload
                        name="demo[]"
                        className="w-full"
                        url="/api/upload"
                        multiple={false}
                        accept="image/*"
                        maxFileSize={1024*1024}
                        onSelect={onUploadImage}
                        onRemove={onRemoveImage}
                    />
                </div>
                <div className="my-2">
                    <label htmlFor="">Category Title *</label>
                    <InputText name={'name'} value={item.name} onChange={handleChange} className="w-full" placeholder="Category title"/>
                </div>
                <div className="p-fluid grid my-2">
                    <div className="col-12 md:col-12">
                        <label htmlFor="">Division *</label>
                        <Dropdown value={selectedCategory} onChange={(e) => {
                            setSelectedCategory(e.value)
                        }} options={category}
                                  optionLabel="name"
                                  placeholder="Select a Category" className="w-full"/>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default NewCategoryModal;